import { useQuery } from '@tanstack/react-query'

import { DatabasesAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { DatabaseOrderBy } from '@makyoapp/makyo-sdk/models/Database'

import { queryKeys } from '@/lib/react-query'
import { fromSdkDbList } from '@/adapters/DbAdapter'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'

/**
 * Get Org databases
 */
export const useGetOrgDatabases = () => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgDatabases, orgID],
    queryFn: () => {
      return DatabasesAPI.ReqList(
        orgID,
        '', // debounceSearch,
        Order.Desc,
        DatabaseOrderBy.CreatedAt
      ).then(fromSdkDbList)
    },
    enabled: !!orgID,
    select(data) {
      return data ?? []
    },
  })
}
